const homepagebanner = () => {
  // Sticky navigation on mobile/tablet
  const navElement = document.querySelector('.homepage-banner-7b__cards-nav');
  const spacerElement = document.querySelector('.homepage-banner-7b__cards-nav-spacer');
  const cardsSection = document.querySelector('.homepage-banner-7b__cards-section');

  if (navElement && cardsSection && window.innerWidth <= 768) {
    const headerHeight = 77;
    let navInitialOffsetTop = null;
    let sectionBottom = null;
    const cardsContent = document.querySelector('.homepage-banner-7b__cards-content');

    // Calculate positions after a small delay to ensure layout is settled
    setTimeout(() => {
      navInitialOffsetTop = navElement.getBoundingClientRect().top + window.pageYOffset;
      sectionBottom = cardsSection.getBoundingClientRect().bottom + window.pageYOffset;
    }, 100);

    const handleScroll = () => {
      if (navInitialOffsetTop === null) return;

      const scrollPos = window.pageYOffset;
      const triggerPoint = navInitialOffsetTop - headerHeight;

      // Stick when scrolled past trigger point and before section bottom
      if (scrollPos >= triggerPoint && scrollPos < sectionBottom) {
        navElement.classList.add('is-sticky');
        if (spacerElement) {
          spacerElement.classList.add('active');
        }
        if (cardsContent) {
          cardsContent.classList.add('nav-is-sticky');
        }
      } else {
        navElement.classList.remove('is-sticky');
        if (spacerElement) {
          spacerElement.classList.remove('active');
        }
        if (cardsContent) {
          cardsContent.classList.remove('nav-is-sticky');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        navElement.classList.remove('is-sticky');
        if (spacerElement) {
          spacerElement.classList.remove('active');
        }
        if (cardsContent) {
          cardsContent.classList.remove('nav-is-sticky');
        }
      }
    });
  } else {
    
  }

  // Enable horizontal scroll on nav with mouse wheel
  if (navElement && window.innerWidth <= 768) {
    navElement.addEventListener('wheel', (e) => {
      // Prevent default vertical scroll
      e.preventDefault();
      // Scroll horizontally instead
      navElement.scrollLeft += e.deltaY;
    }, { passive: false });
  }

  // Handle card navigation for homepage-banner-7b
  const cardNavButtons = document.querySelectorAll('.homepage-banner-7b__cards-nav .card-nav-item');

  if (cardNavButtons.length > 0) {
    cardNavButtons.forEach(button => {
      button.addEventListener('click', function() {
        const cardIndex = this.getAttribute('data-card-index');

        // Remove active class from all nav buttons
        cardNavButtons.forEach(btn => btn.classList.remove('active'));

        // Add active class to clicked button
        this.classList.add('active');

        // On mobile/tablet, scroll to keep tabs visible below fixed header
        if (window.innerWidth <= 768) {
          const navElement = document.querySelector('.homepage-banner-7b__cards-nav');
          const cardsContent = document.querySelector('.homepage-banner-7b__cards-content');
          if (navElement && cardsContent) {
            const headerHeight = 87;
            // Scroll to show the cards content just below the sticky nav
            const cardsContentTop = cardsContent.getBoundingClientRect().top + window.pageYOffset - headerHeight - 80;
            window.scrollTo({
              top: cardsContentTop + 90,
              behavior: 'smooth'
            });
          }
        }

        // Remove active class from all card contents
        const allCards = document.querySelectorAll('.homepage-banner-7b__cards-content .card-content');
        allCards.forEach(card => card.classList.remove('active'));

        // Add active class to corresponding card content
        const activeCard = document.querySelector(`.homepage-banner-7b__cards-content .card-content[data-card-index="${cardIndex}"]`);
        if (activeCard) {
          activeCard.classList.add('active');

          // Reinitialize slick for the active card's USPs
          const $uspSliderDesktop = $(activeCard).find('.card-usps-desktop');
          const $uspSliderMobile = $(activeCard).find('.card-usps-mobile');

          const desktopSlideCount = $uspSliderDesktop.find('.usp-slide').length;
          const mobileSlideCount = $uspSliderMobile.find('.usp-slide').length;

          // Desktop slider
          if ($uspSliderDesktop.length && desktopSlideCount > 1) {
            if ($uspSliderDesktop.hasClass('slick-initialized')) {
              $uspSliderDesktop.slick('unslick');
            }
            $uspSliderDesktop.slick({
              dots: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              fade: true,
              adaptiveHeight: false,
              autoplay: true,
              autoplaySpeed: 5000
            });
          }

          // Mobile slider
          if ($uspSliderMobile.length && mobileSlideCount > 1) {
            if ($uspSliderMobile.hasClass('slick-initialized')) {
              $uspSliderMobile.slick('unslick');
            }
            $uspSliderMobile.slick({
              dots: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              adaptiveHeight: false,
              autoplay: true,
              fade: true,
              autoplaySpeed: 3000
            });
          }
        }
      });
    });
  }

  // Initialize slick for the first active card on page load
  const $firstActiveCard = $('.homepage-banner-7b__cards-content .card-content.active');
  if ($firstActiveCard.length) {
    const $uspSliderDesktop = $firstActiveCard.find('.card-usps-desktop');
    const $uspSliderMobile = $firstActiveCard.find('.card-usps-mobile');

    const desktopSlideCount = $uspSliderDesktop.find('.usp-slide').length;
    const mobileSlideCount = $uspSliderMobile.find('.usp-slide').length;

    // Desktop slider
    if ($uspSliderDesktop.length && desktopSlideCount > 1) {
      $uspSliderDesktop.slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 5000
      });
    }

    // Mobile slider
    if ($uspSliderMobile.length && mobileSlideCount > 1) {
      $uspSliderMobile.slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000
      });
    }
  }
}

export default homepagebanner
